import NewsletterLightbox from './NewsletterLightbox';

export default NewsletterLightbox;
